
import fieldMixin from "@/mixins/field"

export default fieldMixin.extend({
  computed: {
    adaptedPlaceholder (): string {
      return this.placeholder || this.label || this.$t("form.enter") as string
    },
  },
})
